import { render, staticRenderFns } from "./SearchReservationsSeller.vue?vue&type=template&id=0809449a&"
import script from "./SearchReservationsSeller.vue?vue&type=script&lang=js&"
export * from "./SearchReservationsSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports